<template>
  <div id="app" :class="{'warp':headerShow}">
       <Header v-if="headerShow"></Header>
      <router-view/>
      <Footer v-if="footerShow"></Footer>
  </div>
</template>

<script>
import Header from '@/components/header';
import Footer from '@/components/footer';

export default {
  components: {Header, Footer},
  // methods
  data() {
    return {
      headerShow: false,
      footerShow:false,
      noLayout:[,"/register","/login/email"],
      noFooterLayout:[,"/register","/login/email","/my/like"],
    }
  },

  created() {
    this.headerShow = !this.noLayout.includes(this.$route.path);
    this.footerShow = !this.noFooterLayout.includes(this.$route.path);
    this.captureSceneId();
  },
  watch: {
    $route(to, from) {
      this.headerShow =  !this.noLayout.includes(this.$route.path);
      this.footerShow =  !this.noFooterLayout.includes(this.$route.path);
      this.captureSceneId();
    }
  },
  methods: {
    captureSceneId() {
      const querySceneId = this.$route.query && this.$route.query.sceneId;
      const hashSceneId = this.getQueryParam('sceneId');
      const sceneId = querySceneId || hashSceneId;
      if (sceneId) {
        localStorage.setItem('sceneId', sceneId);
      }
    },
    getQueryParam(name) {
      const hash = window.location.hash || '';
      const qIndex = hash.indexOf('?');
      if (qIndex === -1) return null;
      const search = hash.substring(qIndex + 1);
      const params = search.split('&');
      for (let i = 0; i < params.length; i++) {
        const pair = params[i].split('=');
        if (decodeURIComponent(pair[0]) === name) {
          return decodeURIComponent(pair[1] || '');
        }
      }
      return null;
    }
  }
}
</script>

<style lang="less">
@import '@/assets/style/mobile-basic.css';
@import '@/assets/style/el-reset.css';
@import '@/assets/style/cbe.css';


*,p,div,span{
  word-break: normal; /* 防止单词内换行 */
  white-space: pre-wrap; /* 保留空白符并允许换行 */
  overflow-wrap: break-word;
}

@font-face {
  font-family: 'Roboto-Medium';
  src: url('@/assets/fonts/Roboto-Medium.ttf') format('truetype'); /* 可以根据需要添加其他格式 */
  font-weight: normal;
  font-style: normal;
}

@font-face {
  font-family: 'Roboto-Black';
  src: url('@/assets/fonts/Roboto-Black.ttf') format('truetype'); /* 可以根据需要添加其他格式 */
  font-weight: normal;
  font-style: normal;
}

body {
  font-family: 'Roboto-Medium', sans-serif;
}
.warp {
  position: relative;
  //padding: 0 0 0 0;
  background: #F8F8F8;
  padding-top: 30px;
}

.band_tle {
  position: relative;
  font-size: 20px;
  font-weight: bold;
  line-height: 24px;
  color: #000;
  padding-left: 8px;
  border-left: 4px solid #A90000;
}
.sw_btn:hover{
  //background: rgba(169, 0, 0, 0.5);
  border-color: #A90000;
  color: #A90000;
}



.adds_btn,.add_btn{
  color: #A90000
}
.details_left {
  width: 430px;
}
.el-button{
  span{
    white-space: nowrap !important;
  }
}
.wenzi_r{
  color: #666666;
}

</style>
